import React, { useEffect } from 'react';
import {useState, useContext} from 'react';
import ModalTest from '../BaseModal';
import { useNavigate } from 'react-router-dom';
import cross from '../../assets/orders/cross.svg'
import { InputLabel } from '../AddCompanyModal/style';
import { ButtonCreate } from '../routerModal/style';
import TableFiltersContext from '../../contexts/TableFiltersContext';
import UserContext from '../../contexts/UserContext';
import axios from '../../config/axios';
import { ButtonWrapper, CloseDiv, CloseImg, Container, ContentWrapper, FilterItem, HeaderDiv, HeaderText, InfoItem, InfoList, InfoSection, InfoTitle, LeftColumn, RightColumn, SwitchBox, SwitchDiv, SwitchInput, SwitchSlider } from './style';

 const ExportStockModal = () => {
    const [selectedColumns, setSelectedColumns] = useState<boolean>(true);
    const [includeFilters, SetIncludeFilters] = useState<boolean>(true);
    const { stockFilters } = useContext(TableFiltersContext)
    const { user } = useContext(UserContext)
    const [selectedColumnsData, setSelectedColumnsData] = useState<any[]>([])
    const [filter, setFilter] = useState<any[]>(stockFilters)
    const navigate = useNavigate();

    const close = () => {
        navigate('..')
      }

      useEffect(()=>{
        setSelectedColumnsData(JSON.parse(localStorage.getItem('tableFields')|| '[]')[1].whichFieldsToShow.filter((field: { checked: boolean, field: string, fieldName: string }) => field.checked))
      },[])
      const exportSheets = async ()=>{
        try {
          const filters = includeFilters ? stockFilters:[]
          const columns = selectedColumns ? JSON.parse(localStorage.getItem('tableFields')|| '[]')[1].whichFieldsToShow.filter((field: { checked: boolean, field: string, fieldName: string }) => field.checked)
                          : JSON.parse(localStorage.getItem('tableFields')|| '[]')[1].whichFieldsToShow
          const body = {
            filters,
            columns
          }

          const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/export-from-excel`,
              body,
              {
                  responseType:'blob',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  }
              }
          )

          if (response.data instanceof Blob) {
            const url = window.URL.createObjectURL(response.data)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'materiais-exportados.xlsx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          } else {
            console.error('Resposta não é um blob válido:', response.data)
          }
        } catch (error) {
          console.error('Erro na exportação:', error)
        }
      }
    return (
        <>
        <ModalTest>
            <Container>
                <HeaderDiv>
                    <HeaderText>{'Exportar Estoque'}</HeaderText>
                    <CloseDiv onClick={() => close()}>
                        <CloseImg src={cross} alt='Close tab' />
                    </CloseDiv>
                </HeaderDiv>

                <ContentWrapper>
                    <LeftColumn>
                        <SwitchDiv>
                            <InputLabel>Somente colunas selecionadas</InputLabel>
                            <SwitchBox>
                                <SwitchInput
                                    type="checkbox"
                                    onChange={() => setSelectedColumns(!selectedColumns)}
                                    checked={selectedColumns} />
                                <SwitchSlider className="slider"></SwitchSlider>
                            </SwitchBox>
                        </SwitchDiv>

                        <SwitchDiv>
                            <InputLabel>Exportar com filtros</InputLabel>
                            <SwitchBox>
                                <SwitchInput
                                    type="checkbox"
                                    onChange={() => SetIncludeFilters(!includeFilters)}
                                    checked={includeFilters} />
                                <SwitchSlider className="slider"></SwitchSlider>
                            </SwitchBox>
                        </SwitchDiv>

                        <ButtonWrapper>
                            <ButtonCreate style={{height: '2rem', width:'90%'}} onClick={async ()=> await exportSheets()}>
                                Baixar planilha
                            </ButtonCreate>
                        </ButtonWrapper>
                    </LeftColumn>

                    <RightColumn>
                        <InfoSection>
                            <InfoTitle>Colunas Selecionadas ({selectedColumnsData.length})</InfoTitle>
                            <InfoList>
                                {selectedColumnsData.length > 0 ? (
                                    selectedColumnsData.map((column, index) => (
                                        <InfoItem key={index}>
                                            {column.fieldName}
                                        </InfoItem>
                                    ))
                                ) : (
                                    <InfoItem style={{ opacity: 0.6 }}>
                                        Nenhuma coluna selecionada
                                    </InfoItem>
                                )}
                            </InfoList>
                        </InfoSection>

                        <InfoSection>
                            <InfoTitle>Filtros Aplicados ({filter.length})</InfoTitle>
                            <InfoList>
                                {filter.length > 0 ? (
                                    filter.map((filter, index) => (
                                        <FilterItem key={index}>
                                            <strong>{filter.field}</strong> {filter.type} {filter.text}
                                        </FilterItem>
                                    ))
                                ) : (
                                    <InfoItem style={{ opacity: 0.6 }}>
                                        Nenhum filtro aplicado
                                    </InfoItem>
                                )}
                            </InfoList>
                        </InfoSection>
                    </RightColumn>
                </ContentWrapper>
            </Container>
                
</ModalTest>
        </>
    )
}
export default ExportStockModal;
